import React from 'react';
import { ResultsTab } from './types';

export const RESULTS_TABS = [
  { id: 'participants' as ResultsTab, label: 'Participants' },
  { id: 'areas' as ResultsTab, label: 'Areas' },
  { id: 'offices' as ResultsTab, label: 'Offices' },
];

export const CHALLENGE_OPTIONS = [
  { value: 'challenge1', label: 'Challenge 1' },
  { value: 'challenge2', label: 'Challenge 2' },
  { value: 'challenge3', label: 'Challenge 3' },
];

export const getResultsColumns = (activeTab: ResultsTab) => {
  if (activeTab === 'participants') {
    return [
      { id: 'rank', label: 'Rank', width: '5%' },
      { id: 'participant', label: 'Name', width: '20%' },
      { id: 'hours', label: 'Hours', width: '8%' },
      { id: 'clients', label: 'Clients', width: '8%' },
      { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
      {
        id: 'score',
        label: 'Score',
        width: '10%',
        render: (row: any) => <span className="score-value">{row.score}</span>,
      },
      { id: 'area', label: 'Area', width: '10%' },
      { id: 'office', label: 'Office', width: '10%' },
      { id: 'agency', label: 'Agency', width: '10%' },
      { id: 'lastUpdate', label: 'Last Update', width: '14%' },
    ];
  }
  if (activeTab === 'areas') {
    return [
      { id: 'rank', label: 'Rank', width: '5%' },
      { id: 'area', label: 'Area', width: '20%' },
      { id: 'hours', label: 'Hours', width: '8%' },
      { id: 'clients', label: 'Clients', width: '8%' },
      { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
      {
        id: 'score',
        label: 'Score',
        width: '10%',
        render: (row: any) => <span className="score-value">{row.score}</span>,
      },
      { id: 'lastUpdate', label: 'Last Update', width: '14%' },
    ];
  }
  return [
    { id: 'rank', label: 'Rank', width: '5%' },
    { id: 'office', label: 'Office', width: '20%' },
    { id: 'hours', label: 'Hours', width: '8%' },
    { id: 'clients', label: 'Clients', width: '8%' },
    { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
    {
      id: 'score',
      label: 'Score',
      width: '10%',
      render: (row: any) => <span className="score-value">{row.score}</span>,
    },
    { id: 'area', label: 'Area', width: '10%' },
    { id: 'agency', label: 'Agency', width: '10%' },
    { id: 'lastUpdate', label: 'Last Update', width: '14%' },
  ];
};
